(function () {
  if (window.SusucarHeaderStyle6Loaded) return;
  window.SusucarHeaderStyle6Loaded = true;

  function closePanel(panel, restoreFocus) {
    if (!panel || panel.hidden) return;

    panel.hidden = true;
    var trigger = document.querySelector('[data-susu-panel-trigger="' + panel.id + '"]');
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      if (restoreFocus) trigger.focus();
    }
  }

  function closeAllPanels(exceptPanel) {
    document.querySelectorAll('[data-susu-header-panel]').forEach(function (panel) {
      if (panel !== exceptPanel) closePanel(panel, false);
    });
  }

  function togglePanel(trigger) {
    var panelId = trigger.getAttribute('data-susu-panel-trigger');
    var panel = panelId ? document.getElementById(panelId) : null;
    if (!panel) return;

    var shouldOpen = panel.hidden;
    closeAllPanels(panel);
    panel.hidden = !shouldOpen;
    trigger.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
  }

  function closeDesktopMenu(menu) {
    if (!menu) return;
    menu.classList.remove('active');
    var trigger = menu.querySelector(':scope > .wrapper');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  function toggleDesktopMenu(trigger) {
    var menu = trigger.closest('#header-second-nav');
    if (!menu) return;
    var shouldOpen = !menu.classList.contains('active');
    menu.classList.toggle('active', shouldOpen);
    trigger.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
  }

  function collectRoots(root, roots) {
    roots.push(root);
    var elements = root.querySelectorAll ? root.querySelectorAll('*') : [];
    elements.forEach(function (element) {
      if (element.shadowRoot) collectRoots(element.shadowRoot, roots);
    });
  }

  function isVisible(element) {
    if (!element || typeof element.getBoundingClientRect !== 'function') return false;
    var rect = element.getBoundingClientRect();
    var styles = window.getComputedStyle(element);
    return rect.width > 0 && rect.height > 0 && styles.display !== 'none' && styles.visibility !== 'hidden';
  }

  function findInboxLauncher() {
    function inWidget(root) {
      var buttons = root.querySelectorAll('button, [role="button"]');
      for (var n = 0; n < buttons.length; n += 1) {
        if (isVisible(buttons[n]) && /chat|message|conversation/i.test((buttons[n].getAttribute('aria-label') || '') + ' ' + buttons[n].textContent)) return buttons[n];
      }
      var elements = root.querySelectorAll('*');
      for (var j = 0; j < elements.length; j += 1) {
        if (elements[j].shadowRoot) { var nested = inWidget(elements[j].shadowRoot); if (nested) return nested; }
      }
      return null;
    }
    var hosts = document.querySelectorAll('shopify-chat, inbox-online-store-chat, #ShopifyChat, [data-shopify-inbox]');
    for (var hostIndex = 0; hostIndex < hosts.length; hostIndex += 1) {
      var scope = hosts[hostIndex].shadowRoot || hosts[hostIndex];
      var launcher = inWidget(scope);
      if (launcher) return launcher;
    }
    return null;
  }

  function openInbox(button) {
    var panel = button.closest('[data-susu-header-panel]');
    if (panel) { var previousStatus = panel.querySelector('[data-susu-inbox-status]'); if (previousStatus) previousStatus.hidden = true; }

    var customEvent = new CustomEvent('susucar:shopify-inbox:open', {
      bubbles: true,
      cancelable: true,
      detail: { source: button }
    });
    if (!document.dispatchEvent(customEvent)) { closePanel(panel, false); return; }

    var attempts = 0;
    var status = panel ? panel.querySelector('[data-susu-inbox-status]') : null;
    var fallback = button.getAttribute('data-inbox-fallback');

    function tryOpen() {
      var launcher = findInboxLauncher();
      if (launcher && launcher !== button) {
        closePanel(panel, false);
        launcher.focus();
        if (!/close/i.test(launcher.getAttribute('aria-label') || '')) launcher.click();
        return;
      }

      attempts += 1;
      if (attempts < 5) {
        window.setTimeout(tryOpen, 250);
        return;
      }

      if (fallback) {
        window.location.assign(fallback);
        return;
      }

      if (status) {
        status.textContent = 'Live chat is currently unavailable. Please email us.';
        status.hidden = false;
        panel.hidden = false;
      }
    }

    tryOpen();
  }

  document.addEventListener('click', function (event) {
    var mobileDirectLink = event.target.closest('[data-susu-mobile-direct-link]');
    if (!mobileDirectLink) return;

    event.preventDefault();
    event.stopPropagation();
    window.location.assign(mobileDirectLink.href);
  }, true);

  document.addEventListener('click', function (event) {

    var desktopMenuTrigger = event.target.closest('#header-second-nav > .wrapper');
    if (desktopMenuTrigger) {
      event.preventDefault();
      toggleDesktopMenu(desktopMenuTrigger);
      return;
    }

    var panelTrigger = event.target.closest('[data-susu-panel-trigger]');
    if (panelTrigger) {
      event.preventDefault();
      if (panelTrigger.hasAttribute('data-susu-mobile-help')) {
        var drawer = panelTrigger.closest('.drawer');
        var drawerClose = drawer ? drawer.querySelector('.js-btn-close') : null;
        if (drawerClose) drawerClose.click();
        window.setTimeout(function () {
          togglePanel(panelTrigger);
        }, 180);
      } else {
        togglePanel(panelTrigger);
      }
      return;
    }

    var closeButton = event.target.closest('[data-susu-panel-close]');
    if (closeButton) {
      event.preventDefault();
      closePanel(closeButton.closest('[data-susu-header-panel]'), true);
      return;
    }

    var inboxButton = event.target.closest('[data-susu-inbox-trigger]');
    if (inboxButton) {
      event.preventDefault();
      openInbox(inboxButton);
      return;
    }

    if (!event.target.closest('.susu-header-menu')) closeAllPanels();
    if (!event.target.closest('#header-second-nav')) closeDesktopMenu(document.getElementById('header-second-nav'));
  });

  document.addEventListener('keydown', function (event) {
    var desktopMenuTrigger = event.target.closest && event.target.closest('#header-second-nav > .wrapper');
    if (desktopMenuTrigger && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      toggleDesktopMenu(desktopMenuTrigger);
      return;
    }
    if (event.key !== 'Escape') return;
    var openPanel = document.querySelector('[data-susu-header-panel]:not([hidden])');
    if (openPanel) closePanel(openPanel, true);
    closeDesktopMenu(document.getElementById('header-second-nav'));
  });

})();

(function () {
  if (window.SusucarCompactMobileHeader) return;
  var query = window.matchMedia('(max-width: 767px)');
  var entries = new Map();

  function announce() {
    document.dispatchEvent(new CustomEvent('susucar:mobile-header:change'));
  }

  function initialize(root) {
    (root || document).querySelectorAll('.header-style-6 .header-mobile').forEach(function (header) {
      if (entries.has(header)) return;
      var primary = header.querySelector('.susu-mobile-primary');
      var secondary = header.querySelector('.susu-mobile-secondary');
      var menu = primary && primary.querySelector('.js-main-drawer-open-button');
      var logo = primary && primary.querySelector('.header-logo');
      var support = primary && primary.querySelector('.susu-support-menu');
      var account = primary && primary.querySelector('.susu-account-menu');
      var cart = primary && primary.querySelector('.susu-mobile-cart');
      var vehicle = secondary && secondary.querySelector('.susu-mobile-vehicle-button');
      var search = secondary && secondary.querySelector('predictive-search');
      var submit = search && search.querySelector('.susu-search-submit');
      if (!menu || !logo || !cart || !vehicle || !search || !submit) return;

      var controller = new AbortController();
      var moves = [];
      var left = document.createElement('div');
      var right = document.createElement('div');
      left.className = 'susu-mobile-compact-group susu-mobile-compact-left';
      right.className = 'susu-mobile-compact-group susu-mobile-compact-right';
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'susu-mobile-action susu-mobile-search-toggle';
      button.setAttribute('aria-label', submit.getAttribute('aria-label') || 'Search');
      button.setAttribute('aria-expanded', 'false');
      var icon = submit.querySelector('.svg-search') || submit.querySelector('svg');
      if (icon) button.appendChild(icon.cloneNode(true));
      var originalId = secondary.getAttribute('id');
      var originalAccount = account ? { hidden: account.hidden, inert: account.inert } : null;
      var originalOffset = document.documentElement.style.getPropertyValue('--susucar-mobile-sticky-header-offset');
      var id = originalId || 'susu-mobile-search-' + entries.size;
      var active = false;
      var opened = false;

      function measure() {
        if (!active) return;
        var height = primary.getBoundingClientRect().height + (opened ? secondary.getBoundingClientRect().height : 0);
        document.documentElement.style.setProperty('--susucar-mobile-sticky-header-offset', height + 'px');
        announce();
      }

      function closeSearch(restoreFocus) {
        if (!opened) return;
        opened = false;
        header.classList.remove('susu-mobile-search-open');
        button.setAttribute('aria-expanded', 'false');
        if (restoreFocus) button.focus({ preventScroll: true });
        measure();
      }

      function move(node, destination) {
        var marker = document.createComment('susu-mobile-origin');
        node.before(marker);
        moves.push({ node: node, marker: marker });
        destination.appendChild(node);
      }

      function restore() {
        if (!active) return;
        closeSearch(false);
        moves.forEach(function (item) { item.marker.replaceWith(item.node); });
        moves = [];
        left.remove();
        right.remove();
        header.classList.remove('susu-mobile-compact');
        if (account) { account.hidden = originalAccount.hidden; account.inert = originalAccount.inert; }
        if (originalId === null) secondary.removeAttribute('id');
        else secondary.id = originalId;
        if (originalOffset) document.documentElement.style.setProperty('--susucar-mobile-sticky-header-offset', originalOffset);
        else document.documentElement.style.removeProperty('--susucar-mobile-sticky-header-offset');
        active = false;
        announce();
      }

      function synchronize() {
        if (!query.matches) { restore(); return; }
        if (!active) {
          primary.appendChild(left);
          primary.appendChild(right);
          move(menu, left);
          move(vehicle, left);
          right.appendChild(button);
          if (support) move(support, right);
          move(cart, right);
          secondary.id = id;
          button.setAttribute('aria-controls', id);
          if (account) { account.hidden = true; account.inert = true; }
          header.classList.add('susu-mobile-compact');
          active = true;
        }
        measure();
      }

      button.addEventListener('click', function () {
        opened = !opened;
        header.classList.toggle('susu-mobile-search-open', opened);
        button.setAttribute('aria-expanded', String(opened));
        if (opened) {
          header.querySelectorAll('[data-susu-header-panel]:not([hidden]) [data-susu-panel-close]').forEach(function (close) { close.click(); });
          var input = search.querySelector('input[type="search"]');
          if (input) input.focus({ preventScroll: true });
        }
        measure();
      }, { signal: controller.signal });
      document.addEventListener('click', function (event) {
        if (opened && !secondary.contains(event.target) && !button.contains(event.target)) closeSearch(false);
      }, { signal: controller.signal });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && opened) { event.preventDefault(); closeSearch(true); }
      }, { signal: controller.signal });
      query.addEventListener('change', synchronize, { signal: controller.signal });
      var observer = typeof ResizeObserver === 'function' ? new ResizeObserver(measure) : null;
      if (observer) { observer.observe(primary); observer.observe(secondary); }
      entries.set(header, function () { restore(); controller.abort(); if (observer) observer.disconnect(); entries.delete(header); });
      synchronize();
    });
  }

  window.SusucarCompactMobileHeader = { initialize: initialize };
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    entries.forEach(function (cleanup, header) { if (event.target.contains(header)) cleanup(); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  else initialize(document);
})();

/* Only contact links with an explicitly configured WhatsApp number. */
(function () {
  if (window.SusucarContactLinks) return;
  function refresh(link) {
    var number = link.getAttribute('data-susu-whatsapp') || '';
    if (!/^[1-9]\d{6,14}$/.test(number)) return;
    var message = link.getAttribute('data-susu-wa-message') || '';
    if (link.getAttribute('data-susu-wa-page') !== 'false') {
      var page = new URL(window.location.href);
      var variant = page.searchParams.get('variant');
      page.search = ''; page.hash = '';
      if (/\/products\//.test(page.pathname) && /^\d+$/.test(variant || '')) page.searchParams.set('variant', variant);
      message = message ? message + '\n' + page.href : page.href;
    }
    var target = new URL('https://wa.me/' + number);
    if (message) target.searchParams.set('text', message);
    link.href = target.href;
  }
  function initialize(root) { (root || document).querySelectorAll('[data-susu-whatsapp]').forEach(refresh); }
  ['click', 'contextmenu', 'focusin', 'pointerdown'].forEach(function (name) {
    document.addEventListener(name, function (event) {
      var link = event.target.closest && event.target.closest('[data-susu-whatsapp]');
      if (link) refresh(link);
    }, true);
  });
  window.SusucarContactLinks = { initialize: initialize };
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  else initialize(document);
})();

(function () {
  if (window.SusucarDesktopHeaderLayout) return;
  var query = window.matchMedia('(min-width: 992px)');
  var entries = new Map();

  function initialize(root) {
    var headers = [];
    if (root.matches && root.matches('.header-style-6')) headers.push(root);
    if (root.querySelectorAll) root.querySelectorAll('.header-style-6').forEach(function (header) { headers.push(header); });
    headers.forEach(function (header) {
      if (entries.has(header)) return;
      var observed = new Set();
      function measure() {
        if (!query.matches || !header.isConnected) return;
        var top = header.querySelector('.header-desktop .header-content_top');
        var nav = header.querySelector('.header-desktop .header-content_bottom');
        if (!top || !nav) return;
        [top, nav].forEach(function (node) { if (!observed.has(node)) { observer.observe(node); observed.add(node); } });
        var topHeight = top.getBoundingClientRect().height;
        var navHeight = nav.getBoundingClientRect().height;
        if (!topHeight || !navHeight) return;
        var host = header.closest('#header');
        var announcement = host && host.querySelector('.announcement-bar');
        var extraHeight = announcement ? announcement.getBoundingClientRect().height : 0;
        var style = document.documentElement.style;
        style.setProperty('--susucar-desktop-header-height', topHeight + 'px');
        style.setProperty('--susucar-desktop-nav-height', navHeight + 'px');
        style.setProperty('--susucar-desktop-sticky-height', (topHeight + navHeight) + 'px');
        style.setProperty('--susucar-desktop-header-frame-height', (topHeight + navHeight + extraHeight) + 'px');
      }
      var observer = new ResizeObserver(measure);
      observer.observe(header);
      var changes = new MutationObserver(measure);
      changes.observe(header, { childList: true, subtree: true });
      var announcement = header.closest('#header') && header.closest('#header').querySelector('.announcement-bar');
      if (announcement) observer.observe(announcement);
      query.addEventListener('change', measure);
      entries.set(header, function () { observer.disconnect(); changes.disconnect(); query.removeEventListener('change', measure); });
      measure();
    });
  }
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    entries.forEach(function (dispose, header) { if (event.target === header || event.target.contains(header)) { dispose(); entries.delete(header); } });
  });
  window.SusucarDesktopHeaderLayout = { initialize: initialize };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialize(document); }, { once: true });
  else initialize(document);
})();
